import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  MagnifyingGlass, ChatCircle, Package, CheckCircle, ShieldCheck, Scales, Lock,
} from "@phosphor-icons/react";

const steps = [
  { i: MagnifyingGlass, t: "1 · Find the right expert", d: "Browse 14 categories or search by keyword. Filter by tier, rating, price and SEO risk." },
  { i: Package, t: "2 · Choose a package", d: "Every listing has Basic, Standard and Premium — clearly priced with delivery times and revisions." },
  { i: ChatCircle, t: "3 · Submit requirements", d: "Provide brand assets, goals and access via our secure messaging — work starts right after." },
  { i: CheckCircle, t: "4 · Approve & review", d: "Approve delivery to release payment. Request revisions or open a dispute if needed." },
];

export default function HowItWorks() {
  return (
    <div className="bg-white">
      <section className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 py-20 text-center">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-mv-primary mb-3">How it works</div>
        <h1 className="font-display font-black text-4xl lg:text-5xl text-mv-secondary">A clearer, fairer way to buy services.</h1>
        <p className="text-gray-600 mt-4 max-w-2xl mx-auto">Transparent pricing, structured deliverables, escrow-style protection.</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {steps.map(({ i: Icon, t, d }) => (
          <div key={t} className="bg-gray-50 rounded-2xl p-6 border border-gray-200">
            <span className="w-12 h-12 rounded-xl bg-mv-primary text-white flex items-center justify-center mb-4">
              <Icon size={24} weight="duotone" />
            </span>
            <div className="font-display font-bold text-lg text-mv-secondary mb-2">{t}</div>
            <p className="text-sm text-gray-600 leading-relaxed">{d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { i: ShieldCheck, t: "Vetted sellers", d: "Identity & business verification. Tiered: New, Verified, Certified Expert." },
            { i: Scales, t: "Risk transparency", d: "Every SEO service is tagged Low/Medium/High risk so you know what you're buying." },
            { i: Lock, t: "Escrow protection", d: "Payment is held until you approve. Disputes resolved by admin — not the seller." },
          ].map(({ i: Icon, t, d }) => (
            <div key={t} className="bg-white rounded-2xl p-7 border border-gray-200">
              <Icon size={26} weight="duotone" className="text-mv-primary mb-4" />
              <div className="font-display font-bold text-xl text-mv-secondary mb-2">{t}</div>
              <p className="text-sm text-gray-600">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 lg:px-8 pb-24 text-center">
        <h2 className="font-display font-bold text-2xl text-mv-secondary">Ready to start?</h2>
        <div className="mt-4 flex justify-center gap-3">
          <Link to="/browse"><Button className="bg-mv-primary text-white font-bold px-6 py-3 h-auto rounded-xl">Browse services</Button></Link>
          <Link to="/become-a-seller"><Button variant="outline" className="rounded-xl px-6 py-3 h-auto font-bold">Become a seller</Button></Link>
        </div>
      </section>
    </div>
  );
}
